import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import plansReducer from './plansSlice';
import instagramReducer from './instagramSlice';
import facebookReducer from './facebookSlice';
import crmReducer from './crmSlice';
import marketingReducer from './marketingSlice';
import metaAdsReducer from './metaAdsSlice';
import googleAdsReducer from './googleAdsSlice';
import tiktokAdsReducer from './tiktokAdsSlice';
import linkedinAdsReducer from './linkedinAdsSlice';
import youtubeAdsReducer from './youtubeAdsSlice';
import adAnalyticsReducer from './adAnalyticsSlice';
import messengerAutoreplyReducer from './messengerAutoreplySlice';
import emailAutoreplyReducer from './emailAutoreplySlice';
import notificationsReducer from './notificationsSlice';
import adConfigReducer from './adConfigSlice';
import inboxReducer from './inboxSlice';
import whatsappFlowsReducer from './whatsappFlowsSlice';
import metaChatReducer from './metaChatSlice';

// Persistence middleware
const persistenceMiddleware = store => next => action => {
  const result = next(action);

  // Persist auth state to localStorage
  const state = store.getState();
  if (state.auth) {
    localStorage.setItem('authState', JSON.stringify(state.auth));
  }

  return result;
};

// Load persisted auth state
const loadPersistedAuthState = () => {
  try {
    const persistedAuth = localStorage.getItem('authState');
    if (persistedAuth) {
      return JSON.parse(persistedAuth);
    }
  } catch (error) {
    console.error('Failed to load persisted auth state:', error);
  }
  return undefined;
};

const store = configureStore({
  reducer: {
    auth: authReducer,
    plans: plansReducer,
    instagram: instagramReducer,
    facebook: facebookReducer,
    crm: crmReducer,
    marketing: marketingReducer,
    metaAds: metaAdsReducer,
    googleAds: googleAdsReducer,
    tiktokAds: tiktokAdsReducer,
    linkedinAds: linkedinAdsReducer,
    youtubeAds: youtubeAdsReducer,
    adAnalytics: adAnalyticsReducer,
    messengerAutoreply: messengerAutoreplyReducer,
    emailAutoreply: emailAutoreplyReducer,
    notifications: notificationsReducer,
    adConfig: adConfigReducer,
    inbox: inboxReducer,
    whatsappFlows: whatsappFlowsReducer,
    metaChat: metaChatReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(persistenceMiddleware),
  preloadedState: {
    auth: loadPersistedAuthState() || {
      isAuthenticated: false,
      user: null,
      isAdmin: false,
      loading: false,
      error: null,
    },
  },
});

export default store;
